module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("知识库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("库管理")])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "kb-tip"
  }, [_vm._v("上传与建库在此完成；全局助手只做问答。新建可同步创建 IMA 库；备份目录由网盘超管自动创建。")]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('Input', {
    staticStyle: {
      "width": "220px",
      "margin-right": "8px"
    },
    attrs: {
      "placeholder": "名称/外部ID"
    },
    on: {
      "on-enter": _vm.load
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }), _vm._v(" "), _c('Button', {
    on: {
      "click": _vm.load
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.syncing
    },
    on: {
      "click": _vm.openSync
    }
  }, [_vm._v("从 IMA 同步")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": function($event) {
        return _vm.openSave()
      }
    }
  }, [_vm._v("新建知识库")])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.columns,
      "data": _vm.rows,
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "从 IMA 同步知识库"
    },
    model: {
      value: (_vm.syncModal),
      callback: function($$v) {
        _vm.syncModal = $$v
      },
      expression: "syncModal"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 110
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "远程知识库"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "loading": _vm.remoteLoading,
      "placeholder": "下拉选择或下方手输"
    },
    model: {
      value: (_vm.syncExternalId),
      callback: function($$v) {
        _vm.syncExternalId = $$v
      },
      expression: "syncExternalId"
    }
  }, _vm._l((_vm.remoteOptions), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name) + "（" + _vm._s(item.id) + "）")])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "或手输 ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "IMA knowledge_base_id"
    },
    model: {
      value: (_vm.syncExternalIdManual),
      callback: function($$v) {
        _vm.syncExternalIdManual = $$v
      },
      expression: "syncExternalIdManual"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.syncModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.syncing
    },
    on: {
      "click": _vm.doSync
    }
  }, [_vm._v("同步")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "保存知识库"
    },
    model: {
      value: (_vm.saveModal),
      callback: function($$v) {
        _vm.saveModal = $$v
      },
      expression: "saveModal"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 120
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "名称",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "知识库名称"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), (!_vm.form.id) ? _c('Form-item', {
    attrs: {
      "label": "同步创建 IMA"
    }
  }, [_c('i-switch', {
    model: {
      value: (_vm.form.createRemote),
      callback: function($$v) {
        _vm.$set(_vm.form, "createRemote", $$v)
      },
      expression: "form.createRemote"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("开")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("关")])]), _vm._v(" "), _c('span', {
    staticClass: "kb-tip",
    staticStyle: {
      "margin-left": "8px"
    }
  }, [_vm._v("开：后台调 IMA 建库并回填 ID；关：需填已有外部 ID")])], 1) : _vm._e(), _vm._v(" "), (_vm.form.id || !_vm.form.createRemote) ? _c('Form-item', {
    attrs: {
      "label": "外部库 ID",
      "required": !_vm.form.id && !_vm.form.createRemote
    }
  }, [_c('Input', {
    attrs: {
      "disabled": !!_vm.form.id,
      "placeholder": "已有 IMA knowledge_base_id"
    },
    model: {
      value: (_vm.form.externalKbId),
      callback: function($$v) {
        _vm.$set(_vm.form, "externalKbId", $$v)
      },
      expression: "form.externalKbId"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("停用")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.form.remark),
      callback: function($$v) {
        _vm.$set(_vm.form, "remark", $$v)
      },
      expression: "form.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.saveModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.doSave
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "浏览知识库",
      "width": "820"
    },
    model: {
      value: (_vm.browseModal),
      callback: function($$v) {
        _vm.browseModal = $$v
      },
      expression: "browseModal"
    }
  }, [_c('div', {
    staticClass: "browse-bar"
  }, [_c('span', {
    staticClass: "crumb",
    on: {
      "click": _vm.browseGoRoot
    }
  }, [_vm._v("根目录")]), _vm._v(" "), _vm._l((_vm.browseCrumbs), function(c, idx) {
    return _c('span', {
      key: idx
    }, [_vm._v("\n        / "), _c('span', {
      class: ['crumb', idx === _vm.browseCrumbs.length - 1 ? 'current' : ''],
      on: {
        "click": function($event) {
          return _vm.browseGoCrumb(idx)
        }
      }
    }, [_vm._v(_vm._s(c.name))])])
  }), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "180px",
      "margin-left": "12px"
    },
    attrs: {
      "placeholder": "关键词搜索"
    },
    on: {
      "on-enter": _vm.doBrowseSearch
    },
    model: {
      value: (_vm.browseKeyword),
      callback: function($$v) {
        _vm.browseKeyword = $$v
      },
      expression: "browseKeyword"
    }
  }), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.doBrowseSearch
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.browseReload
    }
  }, [_vm._v("刷新")])], 2), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "size": "small",
      "columns": _vm.browseColumns,
      "data": _vm.browseRows,
      "loading": _vm.browseLoading
    }
  }), _vm._v(" "), (!_vm.browseLoading && (!_vm.browseRows || !_vm.browseRows.length)) ? _c('p', {
    staticClass: "kb-tip"
  }, [_vm._v("暂无文件")]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.browseModal = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "上传到知识库"
    },
    model: {
      value: (_vm.uploadModal),
      callback: function($$v) {
        _vm.uploadModal = $$v
      },
      expression: "uploadModal"
    }
  }, [_c('p', {
    staticClass: "kb-tip"
  }, [_vm._v("上传写入 IMA，并备份到网盘（仅网盘超管可见）。")]), _vm._v(" "), _c('p', [_vm._v("目标库：" + _vm._s(_vm.uploadTarget && _vm.uploadTarget.name))]), _vm._v(" "), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.uploadModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.uploading
    },
    on: {
      "click": _vm.doUpload
    }
  }, [_vm._v("开始上传")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52b40886","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kb/KbIndex.vue
// module id = 1795
// module chunks = 8